import {Routes, RouterModule} from "@angular/router";
import {HomeComponent} from "./components/home/home.component";
import {EventListComponent} from "./components/events/event-list/event-list.component";
import {PhotosComponent} from "./components/photos/photos.component";
import {PhotoListComponent} from "./components/photos/photo-list/photo-list.component";
import {AlbumListComponent} from "./components/albums/album-list/album-list.component";
import {AuthGuard} from "./auth-guard.service";
import {ModuleWithProviders} from "@angular/core";
import {MembersComponent} from "./components/members/members.component";
import {MemberListComponent} from "./components/members/member-list/member-list.component";
import {MemberDetailComponent} from "./components/members/member-detail/member-detail.component";
import {FamilyListComponent} from "./components/members/family-list/family-list.component";
import {FamilyDetailComponent} from "./components/members/family-detail/family-detail.component";
import {InvitationListComponent} from "./components/members/invitation-list/invitation-list.component";
import {AlbumDetailComponent} from "./components/albums/album-detail/album-detail.component";
import {ProfileComponent} from "./components/profile/profile.component";
import {UserProfileComponent} from "./components/profile/user-profile/user-profile.component";
import {NotificationComponent} from "./components/profile/notifications/notification.component";
import {BillsComponent} from "./components/profile/bills/bills.component";
import {HelpComponent} from "./components/help/help.component";
import {PremiumComponent} from "./components/help/premium/premium.component";
import {FAQComponent} from "./components/help/faq/faq.component";
import {ContactComponent} from "./components/help/contact/contact.component";
import {BetaComponent} from "./components/home/beta/beta.component";
import {RelativeProfileComponent} from "./components/profile/relative-profile/relative-profile.component";
import {IndexComponent} from "./components/index/index.component";
import {ActivationComponent} from "./components/business/activation/activation.component";
import {BusinessListComponent} from "./components/business/list/business-list.component";
import {EventPageComponent} from "./components/event/event-page.component";
import {EventEditionComponent} from "./components/event/event-edition/event-edition.component";
import {EventCreationComponent} from "./components/event/event-creation/event-creation.component";
import {DashboardPageComponent} from "./components/dashboard/dashboard-page.component";
import {StatsDetailComponent} from "./components/dashboard/stats-detail/stats-detail.component";
import {AdminPageComponent} from "./components/admin/admin-page.component";
import {ProfilePageComponent} from "./components/profile/profile-page.component";
import {PricingPageComponent} from "./components/pricing/pricing-page.component";
import {PremiumPageComponent} from "./components/premium/premium-page.component";
import {HelpPageComponent} from "./components/help/help-page.component";
import {EventDetailComponent} from "./components/event/event-detail/event-detail.component";
import {QrCodeComponent} from "./components/qrcode/qr-code.component";
import {PhotoWallComponent} from "./components/event/photo-wall/photo-wall.component";
import {TopBusinessComponent} from "./components/top-business/top-business.component";
import {PublicPhotoWallComponent} from "./components/event/public-photo-wall/public-photo-wall.component";
import {EventValidationComponent} from "./components/event/event-validation/event-validation.component";
import {DiaporamaComponent} from "./components/event/diaporama/diaporama.component";
import {StripeCallbackComponent} from "./components/premium/stripe-callback/stripe-callback.component";
import {OrderEventComponent} from "./components/premium/order-event/order-event.component";
import {OrderAccountComponent} from "./components/premium/order-account/order-account.component";
import {PaymentSuccessComponent} from "./components/payment/success/payment-success.component";
import {PaymentCanceledComponent} from "./components/payment/canceled/payment-canceled.component";
import {TweetWallComponent} from "./components/event/tweet-wall/tweet-wall.component";


export const ROUTES: Routes = [
  {path: '', component: IndexComponent},
  {
    path: 'activation/:code/:id',
    component: ActivationComponent
  },
  {
    path: 'index/:businessId',
    component: IndexComponent
  },
  {
    path: 'businesses',
    component: BusinessListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'events',
    component: EventPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId',
    component: EventDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/validate',
    component: EventValidationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/edit',
    component: EventEditionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/print',
    component: QrCodeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/wall',
    component: PhotoWallComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/diaporama',
    component: DiaporamaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'event/:eventId/tweet',
    component: TweetWallComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'public/:eventId/wall',
    component: PublicPhotoWallComponent
  },
  {
    path: 'event-creation',
    component: EventCreationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    component: TopBusinessComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'events', component: EventPageComponent},
      {path: 'dashboard', component: DashboardPageComponent},
      {path: 'admins', component: AdminPageComponent}
    ]
  },
  {
    path: 'dashboard',
    component: DashboardPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard/:eventId',
    component: StatsDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'admins',
    component: AdminPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    component: ProfilePageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pricing',
    component: PricingPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'order',
    component: PremiumPageComponent,
    canActivate: [AuthGuard],
    children: [
      {path: 'event/:type', component: OrderEventComponent},
      {path: 'account/:type', component: OrderAccountComponent},
      {path: 'stripe/back', component: StripeCallbackComponent}
    ]
  },
  {
    path: 'payment/accepted',
    component: PaymentSuccessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'payment/success',
    component: PaymentSuccessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'payment/canceled',
    component: PaymentCanceledComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'profile/:tab',
    component: ProfilePageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'help',
    component: HelpPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'help/:tab',
    component: HelpPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'public/event/:eventId',
    component: EventDetailComponent
  }
];

export const authProviders = [
  AuthGuard
];

export const appRoutingProviders: any[] = [
  authProviders
];

export const routing: ModuleWithProviders = RouterModule.forRoot(ROUTES);



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/app.routes.ts